import utils from '@/_modules/utils';

class _footer {
  //constructor() {}

  once(isTop) {
    this.isTop = isTop;
    this.el = document.getElementById('c-footer');
    if (this.el) {
      this.init();
    }
  }

  init() {
    if (this.isTop) {
      // TOPページはアンカーリンクにする
      this.el.querySelectorAll('.is-anchor').forEach((a, i) => {
        a.addEventListener('click', this.anchorLink.bind(this, a.hash.replace('#', '')));
      });
    }
  }

  anchorLink(id, e) {
    e.preventDefault();
    const offset = utils.getOffsetTop(document.getElementById(id));
    gsap.to(window, {
      duration: 0.7,
      scrollTo: {
        y: offset.top,
        autoKill: false,
      },
      ease: Power3.easeOut
    });
  }

  resize() {
    //this.thresholdY = window.innerHeight * 1.2;
  }
}

const footer = new _footer();

export default footer;